module.exports = __webpack_public_path__ + "static/media/food-carton.dd11fb2b.ai";